import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'
import Nav from '../components/nav'

import '../styles/index.sass'
import ScrollTrack from '../components/scroll-track'
import LinksGrid from '../components/links-grid'

import withRouter from 'react-router-dom/withRouter'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import { IntlProvider } from 'react-intl'
import favicon from '../images/favicon.png'

class TransitionHandler extends React.Component {
  shouldComponentUpdate() {
    return this.props.location.pathname === window.location.pathname
  }

  render() {
    const { children } = this.props
    return <div className="transition-container">{children}</div>
  }
}

class Layout extends Component {
  lastKnownScrollPosition = 0
  isTicking = false
  scrollThreshold = 0
  vieportHeight = 0
  isHomepage =
    typeof location !== 'undefined' &&
    (location.pathname === '/' ||
      location.pathname === '/en' ||
      location.pathname === '/en/')

  state = {
    isNavVisible:
      typeof location === 'undefined' || this.isHomepage ? false : true,
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.vieportHeight = window.innerHeight
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componendWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    const isHomepage =
      location.pathname === '/' ||
      location.pathname === '/en' ||
      location.pathname === '/en/'

    this.lastKnownScrollPosition = window.scrollY
    // Imposto la scrollThreshold all'altezza del viewport solo se sono
    // in home. In tutte le altre pagine la nav deve essere sempre visibile
    this.scrollThreshold = isHomepage ? 10 : 0

    if (!this.isTicking) {
      window.requestAnimationFrame(() => {
        this.checkNavVisibility(this.lastKnownScrollPosition)
        this.isTicking = false
      })

      this.isTicking = true
    }
  }

  checkNavVisibility = scrollPosition => {
    if (scrollPosition >= this.scrollThreshold && !this.state.isNavVisible) {
      return this.setState({ isNavVisible: true })
    }

    if (scrollPosition < this.scrollThreshold && this.state.isNavVisible) {
      this.setState({ isNavVisible: false })
    }
  }

  renderGrid = (location, data, locale) => {
    const locationArray = location.pathname.split('/')
    let currentPage = locationArray[1] === '' ? '/' : locationArray[1]

    if (locale === 'en') {
      currentPage = locationArray[2] === '' ? '/' : locationArray[2]
    }

    const allImages = data.allImageSharp.edges

    const imageMap = {
      interviste: allImages.find(
        image => image.node.sizes.src.indexOf('interviste_base') >= 0
      ),
      intervisteHover: allImages.find(
        image => image.node.sizes.src.indexOf('interviste_hover') >= 0
      ),
      mappe: allImages.find(
        image => image.node.sizes.src.indexOf('mappe_base') >= 0
      ),
      mappeHover: allImages.find(
        image => image.node.sizes.src.indexOf('mappe_hover') >= 0
      ),
      eventi: allImages.find(
        image => image.node.sizes.src.indexOf('eventi_base') >= 0
      ),
      eventiHover: allImages.find(
        image => image.node.sizes.src.indexOf('eventi_hover') >= 0
      ),
      pubblicazioni: allImages.find(
        image => image.node.sizes.src.indexOf('pubblicazioni_base') >= 0
      ),
      pubblicazioniHover: allImages.find(
        image => image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0
      ),
      progetto: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_base') >= 0
      ),
      progettoHover: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_hover') >= 0
      ),
    }

    switch (currentPage) {
      case 'progetto':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['eventi', 'mappe', 'interviste', 'pubblicazioni']}
          />
        )
      case 'eventi':
      case 'relazioni-e-conferenze':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'mappe', 'interviste', 'pubblicazioni']}
          />
        )
      case 'mappe':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'eventi', 'interviste', 'pubblicazioni']}
          />
        )
      case 'interviste':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'mappe', 'eventi', 'pubblicazioni']}
          />
        )
      case 'pubblicazioni':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['progetto', 'mappe', 'eventi', 'interviste']}
          />
        )
      case 'gruppo-di-ricerca':
        return (
          <LinksGrid
            imageMap={imageMap}
            links={['eventi', 'mappe', 'interviste', 'pubblicazioni']}
          />
        )
    }
  }

  render() {
    const { children, location, data, locale, messages } = this.props

    const isHomepage =
      location.pathname === '/' ||
      location.pathname === '/en' ||
      location.pathname === '/en/'

    return (
      <IntlProvider locale={locale} messages={messages}>
        <div>
          <Helmet
            link={[
              { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` },
            ]}
          >
            <title>
              Archivio Del Moderno | L'architettura nel Cantone Ticino, 1945 -
              1980
            </title>
          </Helmet>

          {/* Mostro l'header solo nella home */}
          {isHomepage && (
            <Header locale={locale} images={data.allImageSharp.edges} />
          )}

          <Nav locale={locale} visible={this.state.isNavVisible} />

          {/* Mostro lo scrollTrack solo nella pagina Progetto */}
          {location.pathname.startsWith('/progetto') && <ScrollTrack />}

          <TransitionGroup>
            <CSSTransition
              key={location.pathname}
              classNames="fadein"
              timeout={{ enter: 200, exit: 100 }}
            >
              <TransitionHandler location={location}>
                <main className="Main">
                  {children()}

                  {/* Mostro una griglia diversa per ogni pagina */}
                  {this.renderGrid(location, data, locale)}
                </main>
              </TransitionHandler>
            </CSSTransition>
          </TransitionGroup>

          <Footer allImages={data.allImageSharp.edges} />
        </div>
      </IntlProvider>
    )
  }
}

export default withRouter(Layout)



// WEBPACK FOOTER //
// ./src/layouts/index.js